// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// Debug logging has been disabled for production performance.
// To re-enable, uncomment the console.log lines below.

document.addEventListener('flu:cart:item-added', function (evt) {
  // console.log('Item added to the cart', evt.detail.product);
});

document.addEventListener('flu:cart:updated', function (evt) {
  // console.log('Cart updated', evt.detail.cart);
});

document.addEventListener('flu:cart:error', function (evt) {
  // console.log(evt.detail.errorMessage, 'Cart error');
});

document.addEventListener('flu:quick-cart:open', function (evt) {
  // console.log('Quick cart opened', evt.detail.cart);
});

document.addEventListener('flu:quick-cart:close', function () {
  // console.log('Quick cart closed');
});

document.addEventListener('flu:product:variant-change', function (evt) {
  // console.log('Product variant changed', evt.detail.variant);
});

document.addEventListener('flu:product:quantity-update', function (evt) {
  // console.log('Product quantity updated', evt.detail.quantity, evt.detail.variant);
});
